import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";

const FaqSidebarContent = ({ allFaqs, lastPath }) => {
  const { t } = useTranslation("common");
  const { push } = useRouter();

  return (
    <div className="cs-widget my-3">
      <h3 className="cs-widget-title ">{t(`faqs`)}</h3>
      <ul>
        {allFaqs?.map((faq, idx) => (
          <li className="d-flex" key={idx}>
            <i className="fe-book text-muted mt-2 mr-2"></i>
            <div
              role="button"
              onClick={() => {
                push(`/help/faqs/${faq?.key}`);
              }}
            >
              <a
                className={`cs-widget-link ${
                  lastPath === faq?.key ? "active" : ""
                }`}
                style={{ width: "fit-content" }}
              >
                {faq?.name}
              </a>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FaqSidebarContent;
